import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

import type { Point } from "@/lib/map-geometry";

/** Fit the map to every point; a single point is centred at street zoom. */
export function FitBounds({ points }: { points: Point[] }) {
  const map = useMap();
  useEffect(() => {
    if (!map || points.length === 0) return;
    if (points.length === 1) {
      map.setCenter(points[0]);
      map.setZoom(17);
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    for (const p of points) bounds.extend(p);
    map.fitBounds(bounds, 30);
  }, [map, points]);
  return null;
}
